<template>
  <div
    class="d-flex cursor-pointer"
    @click="addElementLocal()"
    :style="elements && elements.length == 0 ? 'height: 20px;' : ''"
  >
    <div class="d-flex flex-wrap">
      <drop
        v-for="(element, elementIndex) in elements"
        :key="elementIndex"
        @drop="onDrop(elementIndex, ...arguments)"
      >
        <drag :transfer-data="elementIndex">
          <b-badge
            variant="primary"
            class="blue-badge"
            tag="div"
            @click.prevent.stop=""
          >
            <!-- <span class="content d-flex justify-content-center align-items-center">Vin Diesel</span> -->
            <input
              class="content d-flex justify-content-center align-items-center transparent-input"
              v-model="element[input_prop_name]"
              type="text"
              :size="element[input_prop_name].length || 1"
              :ref="`pill${elementIndex}`"
            />
            <span
              class="del-btn d-flex justify-content-center align-items-center"
              @click="removeElement(elementIndex)"
              >x</span
            >
          </b-badge>
        </drag>
      </drop>
    </div>

    <!-- Add New Cast & Crew Member -->
    <!-- <div class="d-flex align-items-center border-left ml-auto">
      <button
        v-if="true"
        @click.prevent.stop="addElement()"
        class="btn-transparent"
      >
        <img src="@/assets/img/icons/plus.svg" height="20" width="20" />
      </button>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    elements: {
      type: Array,
      default: () => []
    },
    input_prop_name: {
      type: String,
      default: "value"
    },
    addElement: {
      type: Function
    },
    removeElement: {
      type: Function
    }
  },
  data: function() {
    return {};
  },
  methods: {
    onDrop: function(originalIndex, newElementIndex, event) {
      let elementToBeMoved = this.elements[newElementIndex];
      this.elements.splice(newElementIndex, 1);
      this.elements.splice(originalIndex, 0, elementToBeMoved);
      this.recomputeOrder(this.elements, "order_no");
    },
    recomputeOrder: function(items, prop_name) {
      if (!items || !Array.isArray(items) || !prop_name) return;

      for (let i = 0; i < items.length; i++) {
        items[i][prop_name] = i + 1;
      }
    },
    addElementLocal: function() {
      this.addElement();
      this.$nextTick(() => {
        if (
          this.$refs[`pill${this.elements.length - 1}`] &&
          this.$refs[`pill${this.elements.length - 1}`][0]
        ) {
          this.$refs[`pill${this.elements.length - 1}`][0].focus();
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/EditablePills.vue